import { render, staticRenderFns } from "./MenuIconItem.vue?vue&type=template&id=26f4743c"
import script from "./MenuIconItem.vue?vue&type=script&lang=js"
export * from "./MenuIconItem.vue?vue&type=script&lang=js"
import style0 from "./MenuIconItem.vue?vue&type=style&index=0&id=26f4743c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports